<template>
  <UploadImage
    type="banner"
  />
</template>
<script>
import UploadImage from './components/UploadImage.vue'

export default {
  name: 'UploadBanner',
  components: {
    UploadImage,
  },
}
</script>
